import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { CampaignEditPresenter } from "./presenter";
import { useCampaignEditQuery } from "../../model/repository/existing";

type Props = {
	hotelID: string;
	campaignID: string;
};

export const CampaignEditContainer = ({ hotelID, campaignID }: Props) => {
	const serverModel = useCampaignEditQuery({ hotelID, campaignID });

	if (!serverModel) {
		return <Navigate to={generatePath(PATHS.HOTEL.MARKETING.CAMPAIGN.TOP, { hotelID })} />;
	}

	return <CampaignEditPresenter serverModel={serverModel} />;
};

CampaignEditContainer.displayName = "CampaignEditContainer";
